<template>
  <div>
    <!-- 搜索区域 -->
    <SiruiSearch
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
    ></SiruiSearch>
    <div class="box">
      <sirui-table
        ref="siruiTable"
        :buttonList="menuButtonList"
        :loading="load"
        :data="tableData"
        :paging="true"
        :setting="false"
        :customVisible="true"
        :columns="columnList"
        @chooseClick="chooseClick"
        @dblclickEvent="dblclickEvent"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
      >
        <vxe-table-column
          v-for="(item, index) in columnList"
          :key="index"
          :type="item.type"
          :visible="item.visible"
          :fixed="item.fixed"
          :width="item.width"
          :sortable="item.sortable"
          :field="item.field"
          :title="item.title"
        ></vxe-table-column>
      </sirui-table>
    </div>
  </div>
</template>

<script>
  import SiruiTable from '@/components/SiruiTable';
  import tableMixins from '@/common/mixins/table.js';
  import { mapState } from 'vuex';
  export default {
    name: 'list',
    mixins: [tableMixins],
    components: {
      SiruiTable,
    },
    data() {
      return {
        load: false,
        menuButtonList: [],
        tableData: [],
        columnList: [
          {
            type: 'checkbox',
            width: '50',
            fixed: 'left',
          },
          {
            type: 'index',
            title: '序号',
            width: '50',
            fixed: 'left',
          },
          {
            field: 'companyName',
            title: '公司',
          },
          {
            field: 'modelName',
            title: '功能模块',
          },
          {
            field: 'createBy',
            title: '创建人',
          },
          {
            field: 'gmtCreate',
            title: '创建时间',
          },
          {
            field: 'entityName',
            title: '业务单据类型',
          },
          {
            field: 'enableFlag',
            title: '是否启用',
          },
          {
            field: 'nodeName',
            title: '管控节点',
          },
          {
            field: 'isStrongControl',
            title: '是否强管控',
          },
        ],
        multipleSelection: [], //选中数据
        query: {
          modelCode: '',
          entityCode: '',
          companyCode: '',
        },
        companyList: [],
      };
    },
    computed: {
      ...mapState({
        dictListMap: (state) => state.dict.dictListMap,
      }),
      //搜索字段
      searchColumns() {
        return [
          {
            prop: 'companyCode',
            name: this.$t('公司'),
            type: 'select',
            options: this.companyList,
          },
          {
            prop: 'modelCode',
            name: this.$t('功能模块'),
            type: 'dict',
            dictType: 'Credit_Engine_Model',
            changeMethod: this.changeModel(),
          },
          {
            prop: 'entityCode',
            name: '业务单据类型',
            type: 'dict',
            dictType: this.query.modelCode || 'Credit_Engine_PO',
          },
        ];
      },
    },
    mounted() {
      this.getButtonList();
      this.getData();
      this.getCompany();
      console.log(this.dictListMap);
    },
    methods: {
      changeModel() {
        this.query.entityCode = '';
      },
      getData() {
        this.load = true;
        let params = { ...this.query };
        params.pageSize = this.$refs.siruiTable.page.pageSize;
        params.pageNum = this.$refs.siruiTable.page.pageNum;
        this.$axios.post('/sales/creditLimitEngine/listPage', params).then((res) => {
          this.tableData = res.data.data.list;
          this.$refs.siruiTable.setPageTotal(res.data.data.total);
          this.load = false;
        });
      },
      //获取公司信息
      getCompany() {
        this.$axios
          .get(
            `/maindata/company/listCompanyByTenantCode` + `/${this.userInfo.userInfo.tenantCode}`
          )
          .then((res) => {
            if (res.data.code == 0) {
              this.companyList = res.data.data;
            }
          });
      },
      getButtonList() {
        this.getButtons().then((e) => {
          this.menuButtonList = e;
        });
      },
      chooseClick(type) {
        if (type === 'export') {
          this.export();
        } else if (type === 'delete') {
          this.delete();
        } else if (type === 'add') {
          this.$router.push({
            path: '/credit/controlBillDetail',
            query: {
              type: 'add',
            },
          });
        }
      },
      export() {
        this.$axios.post('/sales/creditLimitEngine/export').then((res) => {
          let url = res.data.data;
          window.open(url, '_blank');
        });
      },
      delete() {
        const selectedList = this.multipleSelection; // 或许选中数据
        let ids = [];
        selectedList.forEach((item) => {
          ids.push(item.id);
        });
        if (selectedList.length < 1) {
          this.$message({
            showClose: true,
            message: this.$t('cooperation.message.noData'),
            type: 'error',
          });
          return;
        }
        this.$axios.post('/sales/creditLimitEngine/delete', { ids: ids }).then((res) => {
          if (0 == res.data.code) {
            //如果操作成功，直接返回列表
            this.$message({
              type: 'success',
              message: this.$t('message.success'),
            });
            this.getData();
          } else {
            //如果有错误返回，提示信息
            this.$alert(res.data.msg);
          }
        });
      },
      dblclickEvent({ row }) {
        this.$router.push({
          path: '/credit/controlBillDetail',
          query: {
            id: row.id,
            type: 'edit',
          },
        });
      },
    },
  };
</script>

<style scoped lang="scss">
  .box {
    background-color: #ffffff;
    padding: 10px 30px 20px;
    margin-top: 10px;
  }
</style>
